import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Tegucigalpa from './img/Tegucigalpa.jpg';
import SanPedroSula from './img/SanPedroSula.png';
import Ceiba from './img/Ceiba.png';
import Juticalpa from './img/Juticalpa.png';
import Choluteca from './img/Choluteca.png';
import SantaRosa from './img/SantaRosa.png';
import SantaBarbara from './img/SantaBarbara.png';
import { Grid, Divider, Box, Link } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import Chip from '@mui/material/Chip';

const cities = [
    {
        name: 'Tegucigalpa',
        image: Tegucigalpa,
        departamento: 'Francisco Morazán',
        location: "14.083674596929736, -87.1891774848847",
        description: 'Colonia Loma Linda Norte, Avenida LA FAO. Blvd. Centroamerica, Tegucigalpa, D.C.',
        url: "https://maps.app.goo.gl/XhjpdFdeUkHxMzZ8A",
        telefono: '+504 2290-1900'
    },
    {
        name: 'San Pedro Sula',
        image: SanPedroSula,
        departamento: 'Cortés',
        location: "15.55332458422777,-88.01297767445857",
        description: 'Carretera Armenta, contiguo a la UTH. Teléfono 2545-6100 al 20',
        url: "https://maps.app.goo.gl/g4ezkqit6FnE8asu5",
        telefono: '+504 2290-1900'
    },
    {
        name: 'Santa Bárbara',
        image: SantaBarbara,
        departamento: 'Santa Bárbara',
        location: "14.918896165602208,-88.23554616587609",
        description: 'Centro Comercial Baide Alvarado, frente al parque central.',
        url: "https://maps.app.goo.gl/HkpQnYbHhCN5YVU17",
        telefono: '+504 2290-1900'
    },
    {
        name: 'Santa Rosa De Copán',
        image: SantaRosa,
        departamento: 'Copán',
        location: "14.76814304880295,-88.7771899721622",
        description: 'Barrio Mercedes, media cuadra de Banco Davivienda Santa Rosa de Copan.',
        url: "https://maps.app.goo.gl/RjbdVRkfH5Xnum6d9",
        telefono: '+504 2290-1900'
    },
    {
        name: 'Juticalpa',
        image: Juticalpa,
        departamento: 'Olancho',
        location: "14.668860531913243, -86.21955659106195",
        description: 'Barrio el centro de Plaza De Bertha, esquina opuesta a la librería Fernando #1.',
        url: "https://maps.app.goo.gl/amUVaL4Z6rFUiLsX6",
        telefono: '+504 2290-1900'
    },
    {
        name: 'La Ceiba',
        image: Ceiba,
        departamento: 'Atlántida',
        location: "15.779135458198608,-86.78853582191947",
        description: 'Barrio Solares nuevos, avenida San Isidro 14 calles, frente a Helados Sarita.',
        url: "https://maps.app.goo.gl/i7M1bHnv6bmNfdSd8",
        telefono: '+504 2290-1900'
    },
    {
        name: 'Choluteca',
        image: Choluteca,
        departamento: 'Choluteca',
        location: "13.307107996849128,-87.1935558358751",
        description: 'Barrio el Centro, frente a iglesia la Merced, zona colonial, Choluteca, Choluteca.',
        url: "https://maps.app.goo.gl/rNAaZQBed18XwMTg6",
        telefono: '+504 2290-1900'
    }
];

export default function Direcciones() {
    const isMobile = useMediaQuery('(max-width:820px)'); // Detectar si es una pantalla móvil
    return (
        <>
            <Grid container justify="center" alignItems="center" marginTop={!isMobile ? 3 : 0}>
                <Grid item xs={12} style={{ textAlign: 'center' }}>
                    <h1>Ubicaciones INJUPEMP</h1>
                </Grid>
            </Grid>
            <Divider sx={{ width: '100%', marginY: 2 }}>
                <b><Chip label="Francisco Morazán" size="medium" /></b>
            </Divider>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {cities.map((city, index) => (
                    <React.Fragment key={index}>
                        <Card sx={{ maxWidth: 600, marginTop: 1, display: 'flex', height: '100%', border: '1px solid #d3d3d3', borderRadius: 3 }}>
                            <Grid container sx={{ height: '100%' }}>
                                <Grid item xs={12} md={6} sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <CardMedia
                                        component="img"
                                        height="190"
                                        image={city.image}
                                        alt={city.name}
                                    />
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Typography gutterBottom variant="h5" component="div" sx={{ display: 'flex', alignItems: 'center' }}>
                                            <LocationOnIcon sx={{ color: 'var(--color-brand-secondary)', marginRight: 1 }} />
                                            <b>{city.name}</b>
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                                            {city.description}
                                        </Typography>
                                        <Divider style={{ marginTop: 3 }}></Divider>
                                        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 1 }}>
                                            <LocalPhoneIcon sx={{ color: 'var(--color-gray-500)', marginRight: 1 }} />
                                            <Link href={`tel:${city.telefono}`} underline="hover" sx={{ color: 'var(--color-gray-500)', textDecoration: 'underline' }}>
                                                {city.telefono}
                                            </Link>
                                        </Box>
                                        <Divider style={{ marginTop: 5 }}></Divider>
                                        <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 1 }}>
                                            <MapIcon sx={{ color: 'var(--color-gray-500)', marginRight: 1 }} />
                                            <Link href={city.url} target="_blank" underline="hover" sx={{ color: 'var(--color-gray-500)', textDecoration: 'underline' }}>
                                                Ver mapa completo
                                            </Link>
                                        </Box>
                                    </CardContent>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Box sx={{ height: '100%' }}>
                                        <iframe
                                            src={`https://maps.google.com/maps?q=${city.location}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                                            width="100%"
                                            height="100%"
                                            style={{ border: 0 }}
                                            allowFullScreen=""
                                            loading="lazy"
                                        ></iframe>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Card>
                        {index < cities.length - 1 &&
                            <Divider sx={{ width: '100%', marginY: 2 }}>
                                <b><Chip label={cities[index + 1].departamento} size="medium" /></b>
                            </Divider>
                        }

                    </React.Fragment>
                ))}
            </Box>
        </>
    );
}

